import * as requestFromServer from "./BooksCrud";
import { callTypes, bookSlice } from "./BooksSlice";

const {actions} = bookSlice;

export const getBooks = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getBooks(queryParams)
    .then(response => {
      dispatch(actions.booksFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllBooks = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllBooks(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getBook = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewBook()
    .then(response => {
      dispatch(actions.bookFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getBook(id)
    .then(response => {
      dispatch(actions.bookFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveBook = branch => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveBook(branch)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteBooks = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteBooks(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanBooksState = () => dispatch => {
  dispatch(actions.booksStateCleaned());
}